import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    ActionTableCell,
    CheckboxTableRow,
    ExTable,
    SelectionFixedFooter,
    TableBody,
    TableHead,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { useFetchTaskMasterSetsApi } from 'api/task_master_set'
import { TaskMasterSet, taskMasterSetKindJa, TaskMasterSetSearchForm } from 'entities/task_master_set'
import { Pagination } from 'components/shared/pagination'
import { useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { taskMasterSetColumnInfoList, TaskMasterSetTableData } from './task_master_set_table'
import { DisplaySetting, DisplaySettingModal, TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { useState } from 'react'
import { EditTaskMasterSetForm, NewTaskMasterSetForm } from './task_master_set_form'
import { Flex } from 'components/shared/flex'

type Props = {
    history: H.History
}

const TaskMasterSetsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<TaskMasterSetSearchForm>()
    const searchForm = useForm<TaskMasterSetSearchForm>(query)
    const api = useFetchTaskMasterSetsApi(searchForm)
    const multipleCheckForm = useMultipleCheckForm<TaskMasterSet>()
    const taskMasterSetDisplaySetting = useDisplaySetting(taskMasterSetColumnInfoList(searchForm), 'TaskMasterSet')
    const displaySettings: DisplaySetting[] = [taskMasterSetDisplaySetting]
    const [selectedTaskMasterSet, setSelectedTaskMasterSet] = useState<TaskMasterSet>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof TaskMasterSetSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`task_master_sets?${queryParams}`)
        }
    }, [searchForm.object])

    return (
        <>
            <EditTaskMasterSetForm
                taskMasterSet={selectedTaskMasterSet}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />
            <ContentHeader
                headerTitle={`タスクテンプレート${query.kind ? `(${taskMasterSetKindJa[query.kind]})` : ''}`}
                left={
                    <>
                        {/* <CopyTableButton /> */}

                        <NewTaskMasterSetForm
                            onComplete={() => {
                                api.execute()
                            }}
                            kind={query.kind}
                        />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} hiddenSearchParams={['kind']} />
                    </>
                }
                right={<DisplaySettingModal displaySettings={displaySettings} />}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <div></div>
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={multipleCheckForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={multipleCheckForm} showEdit>
                                <ActionTableCell th width={60} />
                                <TableHeads displaySetting={taskMasterSetDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={taskMasterSetDisplaySetting.getColumnLength() + 2}>
                            {api.response.results.map((taskMasterSet: TaskMasterSet) => {
                                return (
                                    <CheckboxTableRow key={`taskMasterSet-${taskMasterSet.id}`} item={taskMasterSet} multipleCheckForm={multipleCheckForm}>
                                        <ActionTableCell
                                            action="edit"
                                            onClick={() => {
                                                setSelectedTaskMasterSet(taskMasterSet)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <TaskMasterSetTableData taskMasterSet={taskMasterSet} displaySetting={taskMasterSetDisplaySetting} />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={multipleCheckForm.ids()}
                onClickReset={() => multipleCheckForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="TaskMasterSet"
            ></SelectionFixedFooter>
        </>
    )
}

export default withRouter(TaskMasterSetsPage)
